import React from "react";
import { Link } from "gatsby"

function FooterLinkColumn({ header, items}) {


  return (
    <div className="w-full my-8 lg:my-0 lg:w-4/12 px-4 ml-auto">
      <span className="block uppercase text-white text-sm font-semibold mb-2">
        {header}
      </span>
      <ul className="list-unstyled text-gray-500">
        {items.map((item, index) => (        
          <li key={index}>
            <Link 
              className="hover:text-indigo-600 font-semibold block text-sm py-2"
              to={item.link}
            >
              {item.label}
            </Link>
          </li>       
        ))}
      </ul>
    </div>
  )
}

export default FooterLinkColumn;
